import script from "./edit-workloads-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-workloads-table.vue?vue&type=script&setup=true&lang=ts"

import "./edit-workloads-table.vue?vue&type=style&index=0&id=39ebbebb&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ebbebb"]])

export default __exports__